// Asset Imports
import visa from "../Assets/icons/visa.png";
import americanexpress from "../Assets/icons/amex.png";
import discovercard from "../Assets/icons/discover.png";
import mastercard from "../Assets/icons/mastercard.png";
import googlepay from "../Assets/icons/googlepay.svg";
import googlepayvisa from "../Assets/icons/googlepayvisa.svg";
import googlepaymc from "../Assets/icons/googlepaymastercard.svg";
import googlepayamex from "../Assets/icons/googlepayamericanexpress.svg";

const cardLogos = { visa, americanexpress, discovercard, mastercard, googlepay, googlepayvisa, googlepaymc, googlepayamex };

const CardIcon = ({ cardType, isSmallLogo = false }) => {
  if (!cardType) return null;
  const setIcon = (cardType) => {
    const truncatedCard = cardType?.toLowerCase();
    return (
      <img
        className={isSmallLogo ? "card-type-img-small" : "card-type-img" }
        src={cardLogos[truncatedCard]}
        alt={cardType}
        title={cardType}
      />

    );
  };
  return setIcon(cardType);
};

export default CardIcon;